// extracted by mini-css-extract-plugin
export default {"pre-search-pane-content":"pre-search-pane-content---V4F5I","pre-search-pane-content-label":"pre-search-pane-content-label---oVF0V"};